import { render, staticRenderFns } from "./FragmentRecipe.vue?vue&type=template&id=5cbe28ed&scoped=true"
import script from "./FragmentRecipe.vue?vue&type=script&lang=ts"
export * from "./FragmentRecipe.vue?vue&type=script&lang=ts"
import style0 from "./FragmentRecipe.vue?vue&type=style&index=0&id=5cbe28ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbe28ed",
  null
  
)

export default component.exports